import { render, staticRenderFns } from "./shuibo.vue?vue&type=template&id=25e810fc&scoped=true&"
import script from "./shuibo.vue?vue&type=script&lang=js&"
export * from "./shuibo.vue?vue&type=script&lang=js&"
import style0 from "./shuibo.vue?vue&type=style&index=0&id=25e810fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e810fc",
  null
  
)

export default component.exports